import './toolbar.css';
export default {
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "hidden": "pf-m-hidden",
    "hiddenOnSm": "pf-m-hidden-on-sm",
    "visibleOnSm": "pf-m-visible-on-sm",
    "hiddenOnMd": "pf-m-hidden-on-md",
    "visibleOnMd": "pf-m-visible-on-md",
    "hiddenOnLg": "pf-m-hidden-on-lg",
    "visibleOnLg": "pf-m-visible-on-lg",
    "hiddenOnXl": "pf-m-hidden-on-xl",
    "visibleOnXl": "pf-m-visible-on-xl",
    "hiddenOn_2xl": "pf-m-hidden-on-2xl",
    "visibleOn_2xl": "pf-m-visible-on-2xl",
    "sticky": "pf-m-sticky",
    "static": "pf-m-static",
    "fullHeight": "pf-m-full-height",
    "primary": "pf-m-primary",
    "secondary": "pf-m-secondary",
    "noBackground": "pf-m-no-background",
    "expandAll": "pf-m-expand-all",
    "expanded": "pf-m-expanded",
    "label": "pf-m-label",
    "pagination": "pf-m-pagination",
    "overflowContainer": "pf-m-overflow-container",
    "filterGroup": "pf-m-filter-group",
    "labelGroup": "pf-m-label-group",
    "actionGroup": "pf-m-action-group",
    "actionGroupPlain": "pf-m-action-group-plain",
    "actionGroupInline": "pf-m-action-group-inline",
    "alignStart": "pf-m-align-start",
    "alignCenter": "pf-m-align-center",
    "alignEnd": "pf-m-align-end",
    "flexGrow": "pf-m-flex-grow",
    "alignSelfStretch": "pf-m-align-self-stretch",
    "alignSelfBaseline": "pf-m-align-self-baseline",
    "alignSelfStart": "pf-m-align-self-start",
    "alignSelfCenter": "pf-m-align-self-center",
    "alignSelfEnd": "pf-m-align-self-end",
    "insetNone": "pf-m-inset-none",
    "insetXs": "pf-m-inset-xs",
    "insetSm": "pf-m-inset-sm",
    "insetMd": "pf-m-inset-md",
    "insetLg": "pf-m-inset-lg",
    "insetXl": "pf-m-inset-xl",
    "inset_2xl": "pf-m-inset-2xl",
    "inset_3xl": "pf-m-inset-3xl",
    "inset_4xl": "pf-m-inset-4xl",
    "wrap": "pf-m-wrap",
    "nowrap": "pf-m-nowrap",
    "alignItemsStretch": "pf-m-align-items-stretch",
    "alignItemsBaseline": "pf-m-align-items-baseline",
    "alignItemsStart": "pf-m-align-items-start",
    "alignItemsCenter": "pf-m-align-items-center",
    "alignItemsEnd": "pf-m-align-items-end",
    "gapNone": "pf-m-gap-none",
    "gapXs": "pf-m-gap-xs",
    "gapSm": "pf-m-gap-sm",
    "gapMd": "pf-m-gap-md",
    "gapLg": "pf-m-gap-lg",
    "gapXl": "pf-m-gap-xl",
    "gap_2xl": "pf-m-gap-2xl",
    "gap_3xl": "pf-m-gap-3xl",
    "gap_4xl": "pf-m-gap-4xl",
    "columnGapNone": "pf-m-column-gap-none",
    "rowGapNone": "pf-m-row-gap-none",
    "columnGapXs": "pf-m-column-gap-xs",
    "rowGapXs": "pf-m-row-gap-xs",
    "columnGapSm": "pf-m-column-gap-sm",
    "rowGapSm": "pf-m-row-gap-sm",
    "columnGapMd": "pf-m-column-gap-md",
    "rowGapMd": "pf-m-row-gap-md",
    "columnGapLg": "pf-m-column-gap-lg",
    "rowGapLg": "pf-m-row-gap-lg",
    "columnGapXl": "pf-m-column-gap-xl",
    "rowGapXl": "pf-m-row-gap-xl",
    "columnGap_2xl": "pf-m-column-gap-2xl",
    "rowGap_2xl": "pf-m-row-gap-2xl",
    "columnGap_3xl": "pf-m-column-gap-3xl",
    "rowGap_3xl": "pf-m-row-gap-3xl",
    "columnGap_4xl": "pf-m-column-gap-4xl",
    "rowGap_4xl": "pf-m-row-gap-4xl",
    "toggleGroup": "pf-m-toggle-group",
    "show": "pf-m-show",
    "hide": "pf-m-hide",
    "alignStartOnSm": "pf-m-align-start-on-sm",
    "alignCenterOnSm": "pf-m-align-center-on-sm",
    "alignEndOnSm": "pf-m-align-end-on-sm",
    "flexGrowOnSm": "pf-m-flex-grow-on-sm",
    "alignSelfStretchOnSm": "pf-m-align-self-stretch-on-sm",
    "alignSelfBaselineOnSm": "pf-m-align-self-baseline-on-sm",
    "alignSelfStartOnSm": "pf-m-align-self-start-on-sm",
    "alignSelfCenterOnSm": "pf-m-align-self-center-on-sm",
    "alignSelfEndOnSm": "pf-m-align-self-end-on-sm",
    "insetNoneOnSm": "pf-m-inset-none-on-sm",
    "insetXsOnSm": "pf-m-inset-xs-on-sm",
    "insetSmOnSm": "pf-m-inset-sm-on-sm",
    "insetMdOnSm": "pf-m-inset-md-on-sm",
    "insetLgOnSm": "pf-m-inset-lg-on-sm",
    "insetXlOnSm": "pf-m-inset-xl-on-sm",
    "inset_2xlOnSm": "pf-m-inset-2xl-on-sm",
    "inset_3xlOnSm": "pf-m-inset-3xl-on-sm",
    "inset_4xlOnSm": "pf-m-inset-4xl-on-sm",
    "wrapOnSm": "pf-m-wrap-on-sm",
    "nowrapOnSm": "pf-m-nowrap-on-sm",
    "alignItemsStretchOnSm": "pf-m-align-items-stretch-on-sm",
    "alignItemsBaselineOnSm": "pf-m-align-items-baseline-on-sm",
    "alignItemsStartOnSm": "pf-m-align-items-start-on-sm",
    "alignItemsCenterOnSm": "pf-m-align-items-center-on-sm",
    "alignItemsEndOnSm": "pf-m-align-items-end-on-sm",
    "gapNoneOnSm": "pf-m-gap-none-on-sm",
    "gapXsOnSm": "pf-m-gap-xs-on-sm",
    "gapSmOnSm": "pf-m-gap-sm-on-sm",
    "gapMdOnSm": "pf-m-gap-md-on-sm",
    "gapLgOnSm": "pf-m-gap-lg-on-sm",
    "gapXlOnSm": "pf-m-gap-xl-on-sm",
    "gap_2xlOnSm": "pf-m-gap-2xl-on-sm",
    "gap_3xlOnSm": "pf-m-gap-3xl-on-sm",
    "gap_4xlOnSm": "pf-m-gap-4xl-on-sm",
    "columnGapNoneOnSm": "pf-m-column-gap-none-on-sm",
    "rowGapNoneOnSm": "pf-m-row-gap-none-on-sm",
    "columnGapXsOnSm": "pf-m-column-gap-xs-on-sm",
    "rowGapXsOnSm": "pf-m-row-gap-xs-on-sm",
    "columnGapSmOnSm": "pf-m-column-gap-sm-on-sm",
    "rowGapSmOnSm": "pf-m-row-gap-sm-on-sm",
    "columnGapMdOnSm": "pf-m-column-gap-md-on-sm",
    "rowGapMdOnSm": "pf-m-row-gap-md-on-sm",
    "columnGapLgOnSm": "pf-m-column-gap-lg-on-sm",
    "rowGapLgOnSm": "pf-m-row-gap-lg-on-sm",
    "columnGapXlOnSm": "pf-m-column-gap-xl-on-sm",
    "rowGapXlOnSm": "pf-m-row-gap-xl-on-sm",
    "columnGap_2xlOnSm": "pf-m-column-gap-2xl-on-sm",
    "rowGap_2xlOnSm": "pf-m-row-gap-2xl-on-sm",
    "columnGap_3xlOnSm": "pf-m-column-gap-3xl-on-sm",
    "rowGap_3xlOnSm": "pf-m-row-gap-3xl-on-sm",
    "columnGap_4xlOnSm": "pf-m-column-gap-4xl-on-sm",
    "rowGap_4xlOnSm": "pf-m-row-gap-4xl-on-sm",
    "showOnSm": "pf-m-show-on-sm",
    "hideOnSm": "pf-m-hide-on-sm",
    "alignStartOnMd": "pf-m-align-start-on-md",
    "alignCenterOnMd": "pf-m-align-center-on-md",
    "alignEndOnMd": "pf-m-align-end-on-md",
    "flexGrowOnMd": "pf-m-flex-grow-on-md",
    "alignSelfStretchOnMd": "pf-m-align-self-stretch-on-md",
    "alignSelfBaselineOnMd": "pf-m-align-self-baseline-on-md",
    "alignSelfStartOnMd": "pf-m-align-self-start-on-md",
    "alignSelfCenterOnMd": "pf-m-align-self-center-on-md",
    "alignSelfEndOnMd": "pf-m-align-self-end-on-md",
    "insetNoneOnMd": "pf-m-inset-none-on-md",
    "insetXsOnMd": "pf-m-inset-xs-on-md",
    "insetSmOnMd": "pf-m-inset-sm-on-md",
    "insetMdOnMd": "pf-m-inset-md-on-md",
    "insetLgOnMd": "pf-m-inset-lg-on-md",
    "insetXlOnMd": "pf-m-inset-xl-on-md",
    "inset_2xlOnMd": "pf-m-inset-2xl-on-md",
    "inset_3xlOnMd": "pf-m-inset-3xl-on-md",
    "inset_4xlOnMd": "pf-m-inset-4xl-on-md",
    "wrapOnMd": "pf-m-wrap-on-md",
    "nowrapOnMd": "pf-m-nowrap-on-md",
    "alignItemsStretchOnMd": "pf-m-align-items-stretch-on-md",
    "alignItemsBaselineOnMd": "pf-m-align-items-baseline-on-md",
    "alignItemsStartOnMd": "pf-m-align-items-start-on-md",
    "alignItemsCenterOnMd": "pf-m-align-items-center-on-md",
    "alignItemsEndOnMd": "pf-m-align-items-end-on-md",
    "gapNoneOnMd": "pf-m-gap-none-on-md",
    "gapXsOnMd": "pf-m-gap-xs-on-md",
    "gapSmOnMd": "pf-m-gap-sm-on-md",
    "gapMdOnMd": "pf-m-gap-md-on-md",
    "gapLgOnMd": "pf-m-gap-lg-on-md",
    "gapXlOnMd": "pf-m-gap-xl-on-md",
    "gap_2xlOnMd": "pf-m-gap-2xl-on-md",
    "gap_3xlOnMd": "pf-m-gap-3xl-on-md",
    "gap_4xlOnMd": "pf-m-gap-4xl-on-md",
    "columnGapNoneOnMd": "pf-m-column-gap-none-on-md",
    "rowGapNoneOnMd": "pf-m-row-gap-none-on-md",
    "columnGapXsOnMd": "pf-m-column-gap-xs-on-md",
    "rowGapXsOnMd": "pf-m-row-gap-xs-on-md",
    "columnGapSmOnMd": "pf-m-column-gap-sm-on-md",
    "rowGapSmOnMd": "pf-m-row-gap-sm-on-md",
    "columnGapMdOnMd": "pf-m-column-gap-md-on-md",
    "rowGapMdOnMd": "pf-m-row-gap-md-on-md",
    "columnGapLgOnMd": "pf-m-column-gap-lg-on-md",
    "rowGapLgOnMd": "pf-m-row-gap-lg-on-md",
    "columnGapXlOnMd": "pf-m-column-gap-xl-on-md",
    "rowGapXlOnMd": "pf-m-row-gap-xl-on-md",
    "columnGap_2xlOnMd": "pf-m-column-gap-2xl-on-md",
    "rowGap_2xlOnMd": "pf-m-row-gap-2xl-on-md",
    "columnGap_3xlOnMd": "pf-m-column-gap-3xl-on-md",
    "rowGap_3xlOnMd": "pf-m-row-gap-3xl-on-md",
    "columnGap_4xlOnMd": "pf-m-column-gap-4xl-on-md",
    "rowGap_4xlOnMd": "pf-m-row-gap-4xl-on-md",
    "showOnMd": "pf-m-show-on-md",
    "hideOnMd": "pf-m-hide-on-md",
    "alignStartOnLg": "pf-m-align-start-on-lg",
    "alignCenterOnLg": "pf-m-align-center-on-lg",
    "alignEndOnLg": "pf-m-align-end-on-lg",
    "flexGrowOnLg": "pf-m-flex-grow-on-lg",
    "alignSelfStretchOnLg": "pf-m-align-self-stretch-on-lg",
    "alignSelfBaselineOnLg": "pf-m-align-self-baseline-on-lg",
    "alignSelfStartOnLg": "pf-m-align-self-start-on-lg",
    "alignSelfCenterOnLg": "pf-m-align-self-center-on-lg",
    "alignSelfEndOnLg": "pf-m-align-self-end-on-lg",
    "insetNoneOnLg": "pf-m-inset-none-on-lg",
    "insetXsOnLg": "pf-m-inset-xs-on-lg",
    "insetSmOnLg": "pf-m-inset-sm-on-lg",
    "insetMdOnLg": "pf-m-inset-md-on-lg",
    "insetLgOnLg": "pf-m-inset-lg-on-lg",
    "insetXlOnLg": "pf-m-inset-xl-on-lg",
    "inset_2xlOnLg": "pf-m-inset-2xl-on-lg",
    "inset_3xlOnLg": "pf-m-inset-3xl-on-lg",
    "inset_4xlOnLg": "pf-m-inset-4xl-on-lg",
    "wrapOnLg": "pf-m-wrap-on-lg",
    "nowrapOnLg": "pf-m-nowrap-on-lg",
    "alignItemsStretchOnLg": "pf-m-align-items-stretch-on-lg",
    "alignItemsBaselineOnLg": "pf-m-align-items-baseline-on-lg",
    "alignItemsStartOnLg": "pf-m-align-items-start-on-lg",
    "alignItemsCenterOnLg": "pf-m-align-items-center-on-lg",
    "alignItemsEndOnLg": "pf-m-align-items-end-on-lg",
    "gapNoneOnLg": "pf-m-gap-none-on-lg",
    "gapXsOnLg": "pf-m-gap-xs-on-lg",
    "gapSmOnLg": "pf-m-gap-sm-on-lg",
    "gapMdOnLg": "pf-m-gap-md-on-lg",
    "gapLgOnLg": "pf-m-gap-lg-on-lg",
    "gapXlOnLg": "pf-m-gap-xl-on-lg",
    "gap_2xlOnLg": "pf-m-gap-2xl-on-lg",
    "gap_3xlOnLg": "pf-m-gap-3xl-on-lg",
    "gap_4xlOnLg": "pf-m-gap-4xl-on-lg",
    "columnGapNoneOnLg": "pf-m-column-gap-none-on-lg",
    "rowGapNoneOnLg": "pf-m-row-gap-none-on-lg",
    "columnGapXsOnLg": "pf-m-column-gap-xs-on-lg",
    "rowGapXsOnLg": "pf-m-row-gap-xs-on-lg",
    "columnGapSmOnLg": "pf-m-column-gap-sm-on-lg",
    "rowGapSmOnLg": "pf-m-row-gap-sm-on-lg",
    "columnGapMdOnLg": "pf-m-column-gap-md-on-lg",
    "rowGapMdOnLg": "pf-m-row-gap-md-on-lg",
    "columnGapLgOnLg": "pf-m-column-gap-lg-on-lg",
    "rowGapLgOnLg": "pf-m-row-gap-lg-on-lg",
    "columnGapXlOnLg": "pf-m-column-gap-xl-on-lg",
    "rowGapXlOnLg": "pf-m-row-gap-xl-on-lg",
    "columnGap_2xlOnLg": "pf-m-column-gap-2xl-on-lg",
    "rowGap_2xlOnLg": "pf-m-row-gap-2xl-on-lg",
    "columnGap_3xlOnLg": "pf-m-column-gap-3xl-on-lg",
    "rowGap_3xlOnLg": "pf-m-row-gap-3xl-on-lg",
    "columnGap_4xlOnLg": "pf-m-column-gap-4xl-on-lg",
    "rowGap_4xlOnLg": "pf-m-row-gap-4xl-on-lg",
    "showOnLg": "pf-m-show-on-lg",
    "hideOnLg": "pf-m-hide-on-lg",
    "alignStartOnXl": "pf-m-align-start-on-xl",
    "alignCenterOnXl": "pf-m-align-center-on-xl",
    "alignEndOnXl": "pf-m-align-end-on-xl",
    "flexGrowOnXl": "pf-m-flex-grow-on-xl",
    "alignSelfStretchOnXl": "pf-m-align-self-stretch-on-xl",
    "alignSelfBaselineOnXl": "pf-m-align-self-baseline-on-xl",
    "alignSelfStartOnXl": "pf-m-align-self-start-on-xl",
    "alignSelfCenterOnXl": "pf-m-align-self-center-on-xl",
    "alignSelfEndOnXl": "pf-m-align-self-end-on-xl",
    "insetNoneOnXl": "pf-m-inset-none-on-xl",
    "insetXsOnXl": "pf-m-inset-xs-on-xl",
    "insetSmOnXl": "pf-m-inset-sm-on-xl",
    "insetMdOnXl": "pf-m-inset-md-on-xl",
    "insetLgOnXl": "pf-m-inset-lg-on-xl",
    "insetXlOnXl": "pf-m-inset-xl-on-xl",
    "inset_2xlOnXl": "pf-m-inset-2xl-on-xl",
    "inset_3xlOnXl": "pf-m-inset-3xl-on-xl",
    "inset_4xlOnXl": "pf-m-inset-4xl-on-xl",
    "wrapOnXl": "pf-m-wrap-on-xl",
    "nowrapOnXl": "pf-m-nowrap-on-xl",
    "alignItemsStretchOnXl": "pf-m-align-items-stretch-on-xl",
    "alignItemsBaselineOnXl": "pf-m-align-items-baseline-on-xl",
    "alignItemsStartOnXl": "pf-m-align-items-start-on-xl",
    "alignItemsCenterOnXl": "pf-m-align-items-center-on-xl",
    "alignItemsEndOnXl": "pf-m-align-items-end-on-xl",
    "gapNoneOnXl": "pf-m-gap-none-on-xl",
    "gapXsOnXl": "pf-m-gap-xs-on-xl",
    "gapSmOnXl": "pf-m-gap-sm-on-xl",
    "gapMdOnXl": "pf-m-gap-md-on-xl",
    "gapLgOnXl": "pf-m-gap-lg-on-xl",
    "gapXlOnXl": "pf-m-gap-xl-on-xl",
    "gap_2xlOnXl": "pf-m-gap-2xl-on-xl",
    "gap_3xlOnXl": "pf-m-gap-3xl-on-xl",
    "gap_4xlOnXl": "pf-m-gap-4xl-on-xl",
    "columnGapNoneOnXl": "pf-m-column-gap-none-on-xl",
    "rowGapNoneOnXl": "pf-m-row-gap-none-on-xl",
    "columnGapXsOnXl": "pf-m-column-gap-xs-on-xl",
    "rowGapXsOnXl": "pf-m-row-gap-xs-on-xl",
    "columnGapSmOnXl": "pf-m-column-gap-sm-on-xl",
    "rowGapSmOnXl": "pf-m-row-gap-sm-on-xl",
    "columnGapMdOnXl": "pf-m-column-gap-md-on-xl",
    "rowGapMdOnXl": "pf-m-row-gap-md-on-xl",
    "columnGapLgOnXl": "pf-m-column-gap-lg-on-xl",
    "rowGapLgOnXl": "pf-m-row-gap-lg-on-xl",
    "columnGapXlOnXl": "pf-m-column-gap-xl-on-xl",
    "rowGapXlOnXl": "pf-m-row-gap-xl-on-xl",
    "columnGap_2xlOnXl": "pf-m-column-gap-2xl-on-xl",
    "rowGap_2xlOnXl": "pf-m-row-gap-2xl-on-xl",
    "columnGap_3xlOnXl": "pf-m-column-gap-3xl-on-xl",
    "rowGap_3xlOnXl": "pf-m-row-gap-3xl-on-xl",
    "columnGap_4xlOnXl": "pf-m-column-gap-4xl-on-xl",
    "rowGap_4xlOnXl": "pf-m-row-gap-4xl-on-xl",
    "showOnXl": "pf-m-show-on-xl",
    "hideOnXl": "pf-m-hide-on-xl",
    "alignStartOn_2xl": "pf-m-align-start-on-2xl",
    "alignCenterOn_2xl": "pf-m-align-center-on-2xl",
    "alignEndOn_2xl": "pf-m-align-end-on-2xl",
    "flexGrowOn_2xl": "pf-m-flex-grow-on-2xl",
    "alignSelfStretchOn_2xl": "pf-m-align-self-stretch-on-2xl",
    "alignSelfBaselineOn_2xl": "pf-m-align-self-baseline-on-2xl",
    "alignSelfStartOn_2xl": "pf-m-align-self-start-on-2xl",
    "alignSelfCenterOn_2xl": "pf-m-align-self-center-on-2xl",
    "alignSelfEndOn_2xl": "pf-m-align-self-end-on-2xl",
    "insetNoneOn_2xl": "pf-m-inset-none-on-2xl",
    "insetXsOn_2xl": "pf-m-inset-xs-on-2xl",
    "insetSmOn_2xl": "pf-m-inset-sm-on-2xl",
    "insetMdOn_2xl": "pf-m-inset-md-on-2xl",
    "insetLgOn_2xl": "pf-m-inset-lg-on-2xl",
    "insetXlOn_2xl": "pf-m-inset-xl-on-2xl",
    "inset_2xlOn_2xl": "pf-m-inset-2xl-on-2xl",
    "inset_3xlOn_2xl": "pf-m-inset-3xl-on-2xl",
    "inset_4xlOn_2xl": "pf-m-inset-4xl-on-2xl",
    "wrapOn_2xl": "pf-m-wrap-on-2xl",
    "nowrapOn_2xl": "pf-m-nowrap-on-2xl",
    "alignItemsStretchOn_2xl": "pf-m-align-items-stretch-on-2xl",
    "alignItemsBaselineOn_2xl": "pf-m-align-items-baseline-on-2xl",
    "alignItemsStartOn_2xl": "pf-m-align-items-start-on-2xl",
    "alignItemsCenterOn_2xl": "pf-m-align-items-center-on-2xl",
    "alignItemsEndOn_2xl": "pf-m-align-items-end-on-2xl",
    "gapNoneOn_2xl": "pf-m-gap-none-on-2xl",
    "gapXsOn_2xl": "pf-m-gap-xs-on-2xl",
    "gapSmOn_2xl": "pf-m-gap-sm-on-2xl",
    "gapMdOn_2xl": "pf-m-gap-md-on-2xl",
    "gapLgOn_2xl": "pf-m-gap-lg-on-2xl",
    "gapXlOn_2xl": "pf-m-gap-xl-on-2xl",
    "gap_2xlOn_2xl": "pf-m-gap-2xl-on-2xl",
    "gap_3xlOn_2xl": "pf-m-gap-3xl-on-2xl",
    "gap_4xlOn_2xl": "pf-m-gap-4xl-on-2xl",
    "columnGapNoneOn_2xl": "pf-m-column-gap-none-on-2xl",
    "rowGapNoneOn_2xl": "pf-m-row-gap-none-on-2xl",
    "columnGapXsOn_2xl": "pf-m-column-gap-xs-on-2xl",
    "rowGapXsOn_2xl": "pf-m-row-gap-xs-on-2xl",
    "columnGapSmOn_2xl": "pf-m-column-gap-sm-on-2xl",
    "rowGapSmOn_2xl": "pf-m-row-gap-sm-on-2xl",
    "columnGapMdOn_2xl": "pf-m-column-gap-md-on-2xl",
    "rowGapMdOn_2xl": "pf-m-row-gap-md-on-2xl",
    "columnGapLgOn_2xl": "pf-m-column-gap-lg-on-2xl",
    "rowGapLgOn_2xl": "pf-m-row-gap-lg-on-2xl",
    "columnGapXlOn_2xl": "pf-m-column-gap-xl-on-2xl",
    "rowGapXlOn_2xl": "pf-m-row-gap-xl-on-2xl",
    "columnGap_2xlOn_2xl": "pf-m-column-gap-2xl-on-2xl",
    "rowGap_2xlOn_2xl": "pf-m-row-gap-2xl-on-2xl",
    "columnGap_3xlOn_2xl": "pf-m-column-gap-3xl-on-2xl",
    "rowGap_3xlOn_2xl": "pf-m-row-gap-3xl-on-2xl",
    "columnGap_4xlOn_2xl": "pf-m-column-gap-4xl-on-2xl",
    "rowGap_4xlOn_2xl": "pf-m-row-gap-4xl-on-2xl",
    "showOn_2xl": "pf-m-show-on-2xl",
    "hideOn_2xl": "pf-m-hide-on-2xl"
  },
  "pagination": "pf-v6-c-pagination",
  "toolbar": "pf-v6-c-toolbar",
  "toolbarContent": "pf-v6-c-toolbar__content",
  "toolbarContentSection": "pf-v6-c-toolbar__content-section",
  "toolbarExpandAllIcon": "pf-v6-c-toolbar__expand-all-icon",
  "toolbarExpandableContent": "pf-v6-c-toolbar__expandable-content",
  "toolbarGroup": "pf-v6-c-toolbar__group",
  "toolbarItem": "pf-v6-c-toolbar__item",
  "toolbarToggle": "pf-v6-c-toolbar__toggle"
};